import { render, staticRenderFns } from "./CustomDrugTrialsConfiguration.vue?vue&type=template&id=59cce9aa&scoped=true&"
import script from "./CustomDrugTrialsConfiguration.vue?vue&type=script&lang=js&"
export * from "./CustomDrugTrialsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CustomDrugTrialsConfiguration.vue?vue&type=style&index=0&id=59cce9aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cce9aa",
  null
  
)

export default component.exports